import { IRouter } from "components/Router";
import {
  SSO_ACCOUNT,
  SSO_ACTIVE_ACCOUNT,
  SSO_CALLBACK,
  SSO_EDIT_PROFILE,
  SSO_TENANCY,
  SSO_USER_PROFILE,
  SSO_VIEWER,
} from "constants/router";

const routes: IRouter[] = [
  {
    path: SSO_VIEWER,
    loader: () => import("pages/SSO/index"),
    exact: true,
    type: "auth",
    layout: "auth",
  },
  {
    path: SSO_ACCOUNT,
    loader: () => import("pages/SSO/index"),
    exact: true,
    type: "auth",
    layout: "auth",
  },
  {
    path: SSO_TENANCY,
    loader: () => import("pages/SSO/index"),
    exact: true,
    type: "auth",
    layout: "auth",
  },
  {
    path: SSO_ACTIVE_ACCOUNT,
    loader: () => import("pages/ActiveAccount/index"),
    exact: true,
    type: "auth",
    layout: "auth",
  },
  {
    path: SSO_USER_PROFILE,
    loader: () => import("pages/SSO/index"),
    exact: true,
    type: "auth",
    layout: "auth",
  },
  {
    path: SSO_EDIT_PROFILE,
    loader: () => import("pages/Profile/index"),
    exact: true,
    type: "auth",
    layout: "auth",
  },
  {
    path: SSO_CALLBACK,
    loader: () => import("pages/AuthCallback/index"),
    exact: true,
    type: "auth",
    layout: "auth",
  },
];

export default routes;
